import { FunctionComponent } from "react";
import { faSparkles } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

interface AiHintBannerProps {
	title: string;
	body: string;
	testIdPrefix: string;
}

export const AiHintBanner: FunctionComponent<AiHintBannerProps> = ({
	title,
	body,
	testIdPrefix,
}) => {
	return (
		<div
			className="mt-2 flex items-start gap-2 px-3 py-2 rounded-md bg-purple-100 border-l-4 border-purple-800 text-text"
			data-testid={`${testIdPrefix}-ai-hint-banner`}
		>
			<Icon className="w-4 h-4 text-purple-800 mt-0.5 flex-shrink-0" icon={faSparkles} />
			<div className="text-xs leading-relaxed">
				<strong className="text-purple-800 font-semibold">{title}</strong>
				<span className="text-text-meta"> · {body}</span>
			</div>
		</div>
	);
};
